<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <div class="filter-wrapper">
                    <p class="title">Manage Filters:</p>
                    <div class="filter-container">
                        <div class="filter-item">
                            <date-range-picker :label="created_at_label" control-container-class="nice-select" opens="right" @select="getRange" @clear="clearRange"></date-range-picker>
                        </div>
                        <div class="filter-item">
                            <select class="nice-select" v-model="filters.country" @change="filter_list">
                                <option value="all">Country: All</option>
                                <option v-for="country in countries" :key="country" :value="country">{{ country }}</option>
                            </select>
                        </div>
                        <div class="filter-item">
                            <select class="nice-select" v-model="filters.state" @change="filter_list">
                                <option value="all">State: All</option>
                                <option v-for="row in states" :key="row.state" :value="row.state">{{ row.state }}</option>
                            </select>
                        </div>
                        <div class="filter-item">
                            <select class="nice-select" v-model="filters.corporation_type" @change="filter_list">
                                <option value="all">Corp. Type: All</option>
                                <option>LLC</option>
                                <option>Partnership</option>
                                <option>Sole Proprietor</option>
                                <option>Corporation</option>
                            </select>
                        </div>
                        <div class="filter-item">
                            <select class="nice-select" v-model="filters.status" @change="filter_list">
                                <option value="PENDING">Status: PENDING</option>
                                <option value="APPROVED">APPROVED</option>
                                <option value="REJECTED">REJECTED</option>
                            </select>
                        </div>
                        <div class="filter-item search-filter">
                            <input type="text" placeholder="Search" v-model="filters.search" @change="filter_list">
                            <button type="button" @click="filter_list"><i class="fa fa-search"></i></button>
                        </div>
                        <div class="filter-reset-btn">
                            <a href="javascript:void(0)" title="Refresh" @click="reset_filter">
                                <i class="fa fa-refresh reset-icon" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="table-responsive">
                    <div id="ses-list" class="list-proj" @scroll="scroll_list">
                        <div class="row list-head">
                            <div class="col" data-key="company_name" @click="sort_list">Company</div>
                            <div class="col" data-key="first_name" @click="sort_list">Name</div>
                            <div class="col" data-key="email" @click="sort_list">Email</div>
                            <div class="col" data-key="telephone" @click="sort_list">Telephone</div>
                            <div class="col" data-key="address" @click="sort_list">Address</div>
                            <div class="col" data-key="corporation_type" @click="sort_list">Corp. Type</div>
                            <div class="col" data-key="created_at" @click="sort_list">Reg. Date</div>
                        </div>
                        <div class="list-row" v-for="row in registrations" :key="row.id" :ref="`row${row.id}`">
                            <div class="row list-data">
                                <div class="col">{{ row.company_name }}</div>
                                <div class="col">{{ row.first_name }} {{ row.last_name }}</div>
                                <div class="col" style="word-break: break-word;">{{ row.email }}</div>
                                <div class="col">{{ row.telephone }}</div>
                                <div class="col">{{ row.address }}, {{ row.city }}, {{ row.state }}, {{ row.country }}, {{ row.zipcode }}</div>
                                <div class="col">{{ row.corporation_type }}</div>
                                <div class="col">{{ row.created_at }}</div>
                            </div>
                            <div class="row list-action">
                                <div class="col-md-12 action-wrap">
                                    <badge class="badge-dot mr-4" v-if="row.status != 'PENDING'" :type="row.status.toLowerCase()">
                                        <span class="status">{{ row.status.toLowerCase() }}</span>
                                    </badge>
                                    <div class="action-status" v-if="user.role != 'ses-view' && row.status == 'PENDING'">
                                        <a href="javascript:void(0);" class="action" @click="approve(row.id,row)"><span>+</span> Approve</a>
                                        <a href="javascript:void(0);" class="action action-red" @click="reject(row.id)"><span>-</span> Reject</a>
                                    </div>
                                    <div class="action-links">
                                        <a :href="`/api/public/pdf/user/${row.id}-profile.pdf`" target="_blank">Download PDF</a>
                                        <a href="javascript:void(0);" @click="get_registration(row.id)">View</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <template v-if="registrations.length == 0 && !isListLoading">
                    <p class="no-results-msg">No results found</p>
                </template>
                <template v-if="isListLoading">
                    <div class="progress">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
                    </div>
                </template>
            </div>
        </div>

        <modal class="modal-view" :show="showViewModal" @close="showViewModal = false">
            <template slot="header"><h3>User Registration</h3></template>
            <template>
                <register v-show="!isViewLoading" :registration_obj="registration_obj" :preview="true"></register>
                <div class="text-center" v-show="isViewLoading"><span class="fa fa-spinner fa-pulse"></span></div>
            </template>
        </modal>

        <modal class="modal-approve" :show="showApproveModal" @close="showApproveModal = false">
            <template slot="header"><h3>New Approved User</h3></template>
            <template>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Company Name</label>
                            <input type="text" :class="'form-control s-'+compcheck_status" v-model="company_to_approve">
                            <span><span v-if="compcheck_status === 'success'">&#10004;</span>{{ compcheck_message }}</span>
                            <span style="margin-left: 10px;">
                                <a href="javascript:void(0)" :class="{ 'disabled-link': isCheckingCompany }" @click="checkIfCompanyExists">
                                    <i class="fa fa-refresh reset-icon" aria-hidden="true"></i>
                                    <span v-if="isCheckingCompany" style="margin-left: 5px;">Rechecking...</span>
                                    <span v-else style="margin-left: 5px;">Recheck</span>
                                </a>
                            </span>
                        </div>
                        <div class="form-group">
                            <label>Role <span class="required-indicator">*</span></label>
                            <select class="form-control" ref="role" name="role" v-model="approve_model.role">
                                <option v-for="(role, p) in roles" :key="p" :value="role.role">{{ role.name }}</option>
                            </select>
                        </div>
                        <div class="form-group" v-if="approve_model.role == 'project-manager'">
                            <label>Can Approve <span class="required-indicator">*</span></label>
                            <select class="form-control" ref="can_approve" name="can_approve" v-model="approve_model.can_approve">
                                <option value="1">Yes</option>
                                <option value="0">No</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Customer Code <span class="required-indicator">*</span></label>
                            <input type="text" class="form-control" ref="customer_code" name="customer_code" v-model="approve_model.customer_code">
                        </div>
                        <div class="form-group">
                            <label>Lead BP Code <span class="required-indicator">*</span></label>
                            <input type="text" class="form-control" ref="l_bp_code" name="l_bp_code" v-model="approve_model.l_bp_code">
                        </div>
                        <div class="form-group">
                            <label>Username <span class="required-indicator">*</span></label>
                            <input type="text" class="form-control" ref="username" name="username" v-model="approve_model.username">
                        </div>
                        <div class="form-group">
                            <label>Project Manager</label>
                            <select class="form-control" ref="pm" name="pm" v-model="approve_model.pm">
                                <option v-for="(pm, p) in pms" :key="p" :value="pm.username">{{ pm.username }}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Manager</label>
                            <select class="form-control" ref="managers" name="managers" v-model="approve_model.managers">
                                <option v-for="(pm, p) in managers" :key="p" :value="pm.username">{{ pm.username }}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Distributor</label>
                            <select class="form-control" ref="distributor" name="distributor" v-model="approve_model.distributor">
                                <option v-for="(pm, p) in distributors" :key="p" :value="pm.username">{{ pm.username }}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Email report <span class="required-indicator">*</span></label>
                            <select class="form-control" ref="receive_email" name="receive_email" v-model="approve_model.receive_email">
                                <option value="1">Enabled</option>
                                <option value="0">Disabled</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Pricing <span class="required-indicator">*</span></label>
                            <select class="form-control" ref="pricing" name="pricing" v-model="approve_model.pricing">
                                <option value="1">Enabled</option>
                                <option value="0">Disabled</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Drop Ship Fee <span class="required-indicator">*</span></label>
                            <select class="form-control" ref="add_dropship" name="add_dropship" v-model="approve_model.add_dropship">
                                <option value="0">As Needed</option>
                                <option value="1">Every Order</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>CAD File Download <span class="required-indicator">*</span></label>
                            <select class="form-control" ref="cad_download" name="cad_download" v-model="approve_model.cad_download">
                                <option value="0">Not Allowed</option>
                                <option value="1">Allowed</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Generate 3D <span class="required-indicator">*</span></label>
                            <select class="form-control" ref="export_3D" name="export_3D" v-model="approve_model.export_3D">
                                <option value="1">Yes</option>
                                <option value="0">No</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>5001 Machines <span class="required-indicator">*</span></label>
                            <select class="form-control" ref="allow_5001" name="allow_5001" v-model="approve_model.allow_5001">
                                <option value="0">Not Allowed</option>
                                <option value="1">Allowed</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Discount (%) <span class="required-indicator">*</span></label>
                            <input type="number" min="0" max="100" class="form-control" ref="discount" name="discount" v-model="approve_model.discount">
                        </div>
                    </div>
                </div>
            </template>
            <template slot="footer">
                <button class="btn" @click="showApproveModal = false">Cancel</button>
                <button class="btn btn-black" @click="approveSubmit" :disabled="isApproveSubmitting || isCheckingCompany || compcheck_status === 'failed'">
                    <template v-if="isApproveSubmitting"><span class="fa fa-spinner fa-pulse"></span></template>
                    <template v-else>Confirm</template>
                </button>
                <br>
                <span v-if="compcheck_status === 'failed'" style="color: red;">No Customer Name Match</span>
            </template>
        </modal>

    </div>
</template>
<script>
import Register from '../Register.vue'
import DateRangePicker from '../../components/DateRangePicker'
import moment from 'moment'

export default {
    components: {
        Register,
        DateRangePicker
    },
    data() {
        return {
            isListLoading: false,
            isApproveSubmitting: false,
            isViewLoading: false,
            showApproveModal: false,
            showViewModal: false,
            countries: window.countries,
            states: [],
            registrations: [],
            page: 1,
            last_page: 1,
            order_by: 'created_at',
            order: 'desc',
            company_to_approve: '',
            compcheck_status: '',
            compcheck_message: '',
            filters: {
                search: '',
                created_at: 'all',
                country: 'all',
                state: 'all',
                corporation_type: 'all',
                status: 'PENDING'
            },
            created_at_label: 'Reg. Date: All',
            registration_obj: {},
            registration_id: null,
            managers: false,
            pms: false,
            roles: false,
            distributors: false,
            approve_model: {
                role: '',
                can_approve: 0,
                customer_code: '',
                l_bp_code: '',
                username: '',
                pm: '',
                managers: '',
                distributor: '',
                receive_email: 0,
                pricing: 0,
                add_dropship: 0,
                cad_download: 0,
                export_3D: 0,
                allow_5001: 0,
                discount: 0
            },
            isCheckingCompany: false
        }
    },
    mounted() {
        let def_order = document.querySelector('#ses-list .list-head .col[data-key='+this.order_by+']')
        def_order.classList.add(this.order)
        def_order.dataset.order = (this.order == 'asc' ? 'desc' : 'asc')
        this.get_registrations()
        this.get_list_filters()
        this.get_approve_filters()
    },
    beforeMount() {
        this.user = JSON.parse(localStorage.getItem('user'))
    },
    methods: {
        get_registrations() {
            this.isListLoading = true
            this.$http.get('/api/user_registrations?page=' + this.page
                + '&order_by=' + this.order_by
                + '&order=' + this.order
                + '&filters=' + JSON.stringify(this.filters)
            )
                .then(response => {
                    if(this.page == 1) {
                        this.registrations = []
                    }
                    response.data.data.forEach(row => {
                        this.registrations.push(row)
                    })
                    this.last_page = response.data.last_page
                    this.isListLoading = false
                })
        },
        get_registration(id) {
            this.isViewLoading = true
            this.showViewModal = true
            this.$http.get('/api/user_registrations/' + id)
                .then(response => {
                    this.registration_obj = response.data.data
                    this.isViewLoading = false
                })
        },
        get_list_filters() {
            this.$http.get('/api/ur/list_filters')
                .then(response => {
                    this.states = response.data.states
                })
        },
        get_approve_filters() {
            this.$http.get('/api/user')
                .then((response) => {
                    this.managers = response.data.managers
                    this.roles = response.data.roles
                    this.pms = response.data.pms
                    this.distributors = response.data.distributors
                })
        },
        approve(id,row) {
            this.compcheck_status = ''
            this.compcheck_message = ''
            this.registration_id = id
            this.company_to_approve = row.company_name
            this.checkIfCompanyExists()
            this.showApproveModal = true
        },
        checkIfCompanyExists() {
            this.isCheckingCompany = true
            this.$http.get('/api/check_company/'+this.registration_id, { params: { recheck_company: this.company_to_approve } })
                .then(response => {
                    this.compcheck_status = response.data.status
                    this.compcheck_message = response.data.message
                    this.isCheckingCompany = false
                }).catch(() => {
                this.isCheckingCompany = false
            })
        },
        approveSubmit() {
            this.isApproveSubmitting = true
            this.approve_model.company_name = this.company_to_approve
            this.$http.post('/api/ur/approve/' + this.registration_id, this.approve_model)
                .then(() => {
                    this.reset_approve_form()
                    this.isApproveSubmitting = false
                    this.get_registrations()
                })
                .catch(error => {
                    if(error.response.data.message == 'validation_error') {
                        this.validation_error(error.response.data.errors)
                    } else {
                      alert(error.message);
                    }
                    this.isApproveSubmitting = false
                })
        },
        reject(id) {
            let conf = confirm('Are you sure you want to reject this user?')
            if(conf) {
                this.isListLoading = true
                this.$http.post('/api/ur/reject/' + id)
                    .then(() => {
                        this.$refs[`row${id}`][0].remove()
                        this.isListLoading = false
                    })
                    .catch(() => {
                        alert('Something went wrong!')
                        this.isListLoading = false
                    })
            }
        },
        scroll_list(e) {
            if(e.target.scrollTop + e.target.clientHeight >= (e.target.scrollHeight - 50) && !this.isListLoading) {
                this.page += 1
                if(this.page <= this.last_page) {
                    this.get_registrations()
                }
            }
        },
        sort_list(e) {
            if(!this.isListLoading) {
                Array.from(document.querySelectorAll('#ses-list .list-head .col')).forEach((el) => {
                    el.classList.remove('asc', 'desc')
                })
                let element = document.querySelector('#ses-list .list-head .col[data-key='+e.target.dataset.key+']')
                this.order_by = e.target.dataset.key
                this.order = element.dataset.order || 'asc'
                element.classList.add(this.order)
                element.dataset.order = (this.order == 'asc' ? 'desc' : 'asc')
                this.page = 1
                this.registrations = []
                this.get_registrations()
            }
        },
        filter_list() {
            this.page = 1
            this.registrations = []
            this.get_registrations()
        },
        reset_filter() {
            this.filters = {
                search: '',
                created_at: 'all',
                country: 'all',
                state: 'all',
                corporation_type: 'all',
                status: 'PENDING'
            }
            this.created_at_label = 'Reg. Date: All'
            this.page = 1
            this.registrations = []
            this.get_registrations()
        },
        getRange(range) {
            this.filters.created_at = moment(range.startDate).format('YYYY/MM/DD') + ' - ' + moment(range.endDate).format('YYYY/MM/DD')
            this.created_at_label = this.filters.created_at
            this.filter_list()
        },
        clearRange() {
            this.filters.created_at = 'all'
            this.created_at_label = 'Reg. Date: All'
            this.filter_list()
        },
        validation_error(errors) {
            Array.from(document.querySelectorAll('.hasError')).forEach(function(el) {
                el.classList.remove('hasError');
            })

            for(let el in this.$refs) {
                if(errors[el] !== undefined) {
                    let ref = this.$refs[el]
                    if(Array.isArray(ref)) {
                        ref = ref[0]
                    }
                    ref.classList.add('hasError')
                    if(Object.keys(errors)[0] == el) {
                        ref.focus()
                    }
                }
            }

            if(Object.keys(errors).length == 1) {
                alert(errors[Object.keys(errors)[0]][0])
            } else {
                alert('Please fill all required data.')
            }
        },
        reset_approve_form() {
            this.showApproveModal = false
            this.compcheck_status = ''
            this.compcheck_message = ''
            this.approve_model = {
                role: '',
                can_approve: 0,
                customer_code: '',
                l_bp_code: '',
                username: '',
                pm: '',
                managers: '',
                distributor: '',
                receive_email: 0,
                pricing: 0,
                add_dropship: 0,
                cad_download: 0,
                export_3D: 0,
                allow_5001: 0,
                discount: 0
            }
        }
    }
}
</script>
<style lang="scss" scoped>
#ses-list {
    min-width: 700px;
    padding-right: 12px;
    .list-head {
        .col {
            background-image: url('/api/public/img/bg.png');
            background-position: center right;
            background-repeat: no-repeat;
            cursor: pointer;
            white-space: normal;
            vertical-align: middle;
            &.asc {
                background-image: url('/api/public/img/trans-asc.png');
            }
            &.desc {
                background-image: url('/api/public/img/trans-desc.png');
            }
            &.sort-false {
                background-image: none;
                cursor: default;
            }
        }
    }
}
.form-control.s-failed {
    border-color: red;
}
.form-control.s-failed + span{
    color: red;
}
.progress {
    border-radius: 0;
}
.no-results-msg {
    text-align: center;
    padding: 0.5em;
    font-size: 11px;
}
.row-detail {
    display: flex;
    align-items: center;
    word-break: break-all;
    padding: 0.2em;
    label {
        min-width: 130px;
        font-weight: bold;
        margin: 0;
    }
}
.modal-view.modal::v-deep {
    .modal-dialog {
        max-width: 992px;
    }
}
.modal-approve.modal::v-deep {
    .modal-dialog {
        max-width: 768px;
    }
}
.list-proj .row .action { display: inline-block; padding: 7px; border: 0; letter-spacing: 0.3px; color: #fff; text-decoration: none; min-width: 86px; cursor: pointer; color: #fff; background-color: #5cb85c; margin-left: 6px; vertical-align: middle; }
.list-proj .row .action span { display: inline-block; background: #459e45; padding: 2px 7px; width: 29px; margin: -7px 2px -7px -8px; font-size: 17px; line-height: 26px; text-align: center; }
.list-proj .row .action.action-red { background: #c90000; }
.list-proj .row .action.action-red span { background: #8b0000; }
.badge {
    cursor: text;
    pointer-events: none;
    border-radius: 0;
    min-width: 84px;
    padding: 7px;
    border: 0;
    letter-spacing: .3px;
    color: #fff;
    text-decoration: none;
}
.badge-pending {
    background-color: gold;
}
.badge-approved {
    background-color: #459e45;
}
.badge-rejected {
    background-color: #c90000;
}
@media (max-width: 768px) {
    #ses-list {
        min-width: 1200px;
    }
}
@media (min-width: 1200px) {
    .filter-wrapper {
        .filter-item {
            width: 19.4%;
            &.search-filter {
                width: 29.6% !important;
            }
        }
    }
}
.disabled-link {
  pointer-events: none !important;
}
</style>
